<template>
  <div>
    <v-row>
      <v-col>
        <v-checkbox
          v-model="shouldSync"
          class="mt-1"
          label="Sync with Tmetric?"
          :disabled="!isAPIKeyValid"
          hide-details
        />
      </v-col>
    </v-row>

    <v-divider />

    <v-row>
      <v-col>
        <v-select
          v-model="tmetricClientId"
          :items="tmetricClients"
          item-text="clientName"
          item-value="clientId"
          :disabled="canNotSync()"
          label="Client"
          class="my-2"
          @blur="v$.tmetricClientId.$touch"
          @change="onChange"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="budgetSize"
          :disabled="canNotSync()"
          label="Time Budget (in hours)"
          type="number"
          @blur="v$.budgetSize.$touch"
          @change="onChange"
        />
      </v-col>
    </v-row>

    <v-row v-if="v$.$errors">
      <v-col>
        <p
          v-for="error of v$.$errors"
          :key="error.$uid"
          class="error--text"
        >
          <strong>{{ error.$message }}</strong>
        </p>
      </v-col>
    </v-row>

    <template v-if="isAPIKeyValid === false">
      <v-row>
        <v-col>
          <v-alert
            icon="$error"
            text
            type="error"
          >
            The Tmetric account is not properly set up. Check in with an admin or check the Tmetric API
            key validity in the site settings if you have this ability.
          </v-alert>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { helpers, required } from '@vuelidate/validators'
import { mapActions, mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { SETTINGS_NAMESPACE } from '@/store/settings'
import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'CaseTmetricFields',

  setup () {
    return {
      v$: useVuelidate(),
    }
  },

  data () {
    return {
      budgetSize: null,
      isAPIKeyValid: null,
      shouldSync: false,
      tmetricClientId: null,
    }
  },

  computed: {

    ...mapGetters(SHARED_NAMESPACE, [
      'tmetricClients',
    ]),
  },

  async created () {
    await this.isTmetricAPIKeyValid()
    this.getTmetricClients()
  },

  validations () {
    return {
      budgetSize: { required: helpers.withMessage('Please provide a time budget.', required) },
      tmetricClientId: { required: helpers.withMessage('Please pick a client.', required) },
    }
  },

  methods: {
    canNotSync () {
      return !this.shouldSync || !this.isAPIKeyValid
    },

    async isTmetricAPIKeyValid () {
      this.isAPIKeyValid = null
      this.isAPIKeyValid = await this.pingTmetric()
    },

    onChange () {
      this.$emit('update', {
        budgetSize: this.budgetSize,
        tmetricClientId: this.tmetricClientId,
      })
    },

    ...mapActions(SETTINGS_NAMESPACE, [
      'pingTmetric',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getTmetricClients',
    ]),
  },
}
</script>
